export const sendClarityEvent = (key, value) => {
	if (window.clarity) {
		window.clarity("event", key + (value ? ` ${value}` : ""));
	}
};

export const sendGTMEvent = (event, data = {}) => {
	console.log("GTM Event:", event, data);
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({ event, ...data });
};
